var _path, _rect, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 2.25043C6.17525 2.25043 2.25 6.17563 2.25 11.0003C2.25 15.8252 6.17525 19.7504 11 19.7504C15.8247 19.7504 19.75 15.8252 19.75 11.0003C19.75 6.17563 15.8247 2.25043 11 2.25043ZM10.9999 22.0004C4.9346 22.0004 0 17.0658 0 11.0003C0 4.93503 4.9346 0.000427246 10.9999 0.000427246C17.0652 0.000427246 21.9998 4.93503 21.9998 11.0003C21.9998 17.0658 17.0652 22.0004 10.9999 22.0004Z",
    fill: "#836B55"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.87207,
    y: 8.39161,
    width: 1.9744,
    height: 9.37838,
    rx: 0.987198,
    fill: "#836B55"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8592 7.10345C11.6773 7.10345 12.34 6.44049 12.34 5.62282C12.34 4.80481 11.6773 4.14185 10.8592 4.14185C10.0411 4.14185 9.37842 4.80481 9.37842 5.62282C9.37842 6.44049 10.0411 7.10345 10.8592 7.10345Z",
    fill: "#836B55"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSign);
export default __webpack_public_path__ + "static/media/sign.5098744b30c2f330765b21c247c34b95.svg";
export { ForwardRef as ReactComponent };